<template>
  <div>
    <div v-if="isVisible" class="dialog-overlay">
      <div class="dialog-content">
        <div class="dialog-body">
          <div class="dialog-title">{{ title }}</div>
          <div class="dialog-message">{{ message }}</div>
          <div class="dialog-buttons">
            <div class="cancel-btn btn" @click="cancel">{{ cancelText }}</div>
            <div class="confirm-btn btn" @click="confirm">{{ confirmText }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {
        isVisible: false,
        title: '',
        message: '',
        cancelText: '取消',
        confirmText: '确认',
        resolve: null,
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      open(options = {}) {
        this.title = options.title || '提示';
        this.message = options.message || '';
        this.cancelText = options.cancelText || '取消';
        this.confirmText = options.confirmText || '确认';
        this.isVisible = true;

        // 返回一个 Promise，用于操作后的回调
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      cancel() {
        this.isVisible = false;
        if (this.resolve) this.resolve(false); // 传递取消状态
      },
      confirm() {
        this.isVisible = false;
        if (this.resolve) this.resolve(true); // 传递确认状态
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    .dialog-content {
      width: 300px;
      height: 190px;
      background-color: rgba(248, 248, 248, 1);
      border-radius: 12px;
      .dialog-body {
        padding: 0 16px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        .dialog-title {
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: bold;
        }
        .dialog-message {
          flex: 1;
          font-size: 13px;
        }
        .dialog-buttons {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 60px;
          .btn:hover {
            cursor: pointer;
          }
          .btn {
            width: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.04);
            height: 40px;
            border-radius: 8px;
            color: rgba(51, 51, 51, 1);
            font-weight: bold;
            font-size: 13px;
          }
          .confirm-btn {
            background-color: rgba(255, 236, 234, 1);
            color: rgba(254, 51, 24, 1);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/notice_dialog.vue